import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PreCadastroService } from '@app/modules/cliente/services/pre_cadastro.service';
import { ILinhaProducao } from '@app/modules/linha_producao/models/linha_producao.model';
import { LinhaProducaoService } from '@app/modules/linha_producao/services/linha_producao.service';
import { ModeloService } from '@app/modules/modelos/services/modelo.service';
import { IVendedor } from '@app/modules/vendedor/models/vendedor.model';
import { VendedorService } from '@app/modules/vendedor/services/vendedor.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Dialog } from 'primeng/dialog';
import {
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';

@Component({
  selector: 'dialog-dashboard-filtros',
  templateUrl: './dialog-dashboard-filtros.component.html',
  providers: [
    LinhaProducaoService,
    PreCadastroService,
    ModeloService,
    VendedorService
  ]
})
export class DialogDashboardFiltrosComponent implements OnInit, AfterViewInit {
  @ViewChild('dashboardFiltros') dashboardFiltros: Dialog;

  public keywordFormDateRange = new UntypedFormControl();
  public keywordFormDateRangeStart = new UntypedFormControl();
  public keywordFormDateRangeEnd = new UntypedFormControl();
  public linhaProducaoControl = new UntypedFormControl();
  public preCadastroControl = new UntypedFormControl();
  public vendedorControl = new UntypedFormControl();
  public modeloControl = new UntypedFormControl();

  maxDate = new Date();
  minDateField = new Date(new Date().setDate(new Date().getDate() - 90));
  minDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  viewInit = false;
  linhaProdId: string;

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public linhaProducaoService: LinhaProducaoService,
    public preCadastroService: PreCadastroService,
    public vendedorService: VendedorService,
    public modeloService: ModeloService,
    public tokenService: TokenService,
    public matDialogRef: MatDialogRef<DialogDashboardFiltrosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.keywordFormDateRange.setValue(data.keywordFormDateRange.value);
    this.keywordFormDateRangeStart.setValue(
      data.keywordFormDateRangeStart.value
    );
    this.keywordFormDateRangeEnd.setValue(data.keywordFormDateRangeEnd.value);
    this.linhaProducaoControl.setValue(data.linhaProducaoControl.value);
    this.preCadastroControl.setValue(data.preCadastroControl.value);
    this.vendedorControl.setValue(data.vendedorControl.value);
    this.modeloControl.setValue(data.modeloControl.value);
  }

  ngAfterViewInit() {
    this.dashboardFiltros.maximize();
  }

  public ngOnInit() {
    this.keywordFormDateRange.valueChanges.subscribe(value => {
      if (value) {
        if (value[0]) this.keywordFormDateRangeStart.setValue(value[0]);
        if (value[1]) {
          this.keywordFormDateRangeEnd.setValue(value[1]);
        }
      }
    });
  }

  fillLinhaValue(linha: ILinhaProducao) {
    this.linhaProdId = linha.id;
    this.modeloControl.reset();
  }

  displayVendedor(vendedor: IVendedor): string {
    if (!vendedor) {
      return '';
    }
    return vendedor.parceiro.apelido_nome_fantasia;
  }

  get domainId() {
    return this.tokenService.getDomain().id;
  }

  get disableClearFilter() {
    return !(
      this.modeloControl.value ||
      this.preCadastroControl.value ||
      this.linhaProducaoControl.value ||
      // this.keywordFormDateRange.value ||
      this.vendedorControl.value
    );
  }

  get disableApplyFilter() {
    return !(
      this.modeloControl.value ||
      this.preCadastroControl.value ||
      this.linhaProducaoControl.value ||
      this.keywordFormDateRange.value ||
      this.vendedorControl.value
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.dialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: txtMsg,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.checkError();
  }
}
